import React from 'react';
import './Button.scss';
import cn from 'classnames';

const Button = ({
  Icon,
  iconColor,
  iconSize = 20,
  onClick,
  text,
  color = 'red',
  isDisabled = false,
  isLoading = false,
  isInverse = false,
  isStretch = false,
  smallerText = false,
  EndIcon,
  ...rest
}) => {
  const isButtonDisabled = isDisabled || isLoading;

  return (
    <button
      {...rest}
      className={cn('button', `${color}`, { disabled: isButtonDisabled }, { inverse: isInverse }, { stretch: isStretch }, { 'with-end-icon': !!EndIcon })}
      onClick={onClick}
      disabled={isButtonDisabled}>
      {Icon && <Icon color={iconColor} width={iconSize} height={iconSize} />}
      {isLoading && <div className="button-spinner" />}
      <span className={cn({ smallerText: smallerText })}>{text}</span>
      {EndIcon && <EndIcon color={iconColor} />}
    </button>
  );
};

export default Button;
